
            const data = {"name":"feather/video-off","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10M1 1l22 22\"/>","originalColors":[],"stopColors":[]}}
        
                module.exports = data
                